import {
  Row,
  Col,
  Container,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import laptop from "assets/image/laptop.png";
import Report from "assets/image/report.png";
import Hourglass from "assets/image/hourglass.png";
import Pen from "assets/image/pen.png";
import BankCard from "assets/image/bank-card.png";
import cn from "classnames";
import QrCode from "assets/image/qrCode.png";
import "assets/styles/components/speechBubble.scss";
import "assets/styles/components/lists.scss";
import "assets/styles/components/variantProperty.scss";
import "assets/styles/components/modal.scss";
import { useState } from "react";
export default function Services() {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const array = [
    {
      title: "Deposit and withdrawal without restrictions",
      content: "With Coinnik wallet, you can deposit and withdraw blockchains.",
      icon: Report,
    },
    {
      title: "Payment by acceleration card",
      content:
        "It is possible to buy and sell cryptocurrencies through Shetab member bank cards.",
      icon: BankCard,
    },
    {
      title: "Low and reasonable commission",
      content:
        "Kevin Nick Market commissions are low, and as the volume of transactions increases, the amount of commissions decreases.",
      icon: Pen,
    },
    {
      title: "View open orders and volume of exchanges",
      content:
        "All open orders and trading volume of Kevin Nick Market can be seen.",
      icon: Hourglass,
    },
  ];

  return (
    <Container className="py-6 service_parent">
      <Row>
        <Col
          xs="12"
          className="d-flex flex-column align-items-center justify-content-center pb-5"
        >
          <span className="text-warning-light fw-medium fs-6 pb-2 ">
            {t("Services")}
          </span>
          <span className="fs-5 text-primary-light fw-bold ">
            {t("What services does Kevin Nick Market have?")}
          </span>
        </Col>
      </Row>
      <Row>
        <Col
          xs="12"
          sm="12"
          lg="6"
          xl="6"
          className="d-flex flex-column  align-items-center justify-content-center"
        >
          <img src={laptop} className="w-100" />
        </Col>
        <Col />
        <Col xs="12" sm="12" lg="5" xl="5">
          {array.map((item) => (
            <Row className="d-flex align-items-center py-4">
              <Col xs="3" lg="2">
                <img src={item.icon} />
              </Col>
              <Col xs="9" className="d-flex flex-column ">
                <span className="text-secondary-seven-light fw-medium">
                  {t(item.title)}
                </span>
                <span className="text-secondary-three-light">
                  {t(item.content)}
                </span>
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
      {/* <Row className="pt-2">
        <Col
          xs="12"
          className="d-flex align-items-center justify-content-center"
        >
          <Button size="xs" color="dark" className="mx-1">
            <ButtonContent
              heroTitle={t("Bazaar Cafe application")}
              subTitle={t("Get from")}
              icon={t("icon-market")}
            />
          </Button>
          <Button size="xs" color="dark">
            <ButtonContent
              heroTitle={t("Direct link")}
              subTitle={t("Get from")}
              icon={t("icon-market")}
            />
          </Button>

          <Button
            size="xs"
            color="dark"
            className="mx-1 d-none d-sm-block qrcode-button-style"
            onClick={() => setModalOpen(!modalOpen)}
          >
            <i className="icon-qrcode  d-flex align-items-center" />
          </Button>

          <Modal
            toggle={() => setModalOpen(!modalOpen)}
            isOpen={modalOpen}
            centered={true}
            size="md"
          >
            <Row className="modal-header ">
              <Col xs="2">
                <span
                  className="icon-close"
                  onClick={() => setModalOpen(!modalOpen)}
                ></span>
              </Col>

              <Col xs="10">
                <h5 className="modal-title text-nowrap">
                  {t("Scan to download the app")}
                </h5>
              </Col>
            </Row>
            <ModalBody className="d-flex justify-content-center py-5 ">
              <img src={QrCode} />
            </ModalBody>
          </Modal>
        </Col>
      </Row> */}
    </Container>
  );
}

// const ButtonContent = ({ heroTitle, subTitle, icon }: any) => (
//   <div className="d-flex flex-row align-items-center button-padding-y">
//     <span className="d-flex  flex-column align-items-start">
//       <span className="fs-10 text-white">{subTitle}</span>
//       <span className="fs-8 d-flex align-items-center">{heroTitle}</span>
//     </span>
//     <i className={cn(" d-flex align-items-center pe-3", icon)} />
//   </div>
// );
